import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

const SLIDE_GAP = 16;

interface SwiperItemContainerProps {
  slideItemWidth: number;
  slideItems: JSX.Element[];
  extraElement?: {
    width: number;
    element: JSX.Element;
  };
}

// TODO : 가로 형태의 리스트 방식을 사용하는 곳, CustomSwiper 를 자체 구현하여 사용하고 있는 곳에 SwiperItemContainer 적용 https://gint-team.atlassian.net/browse/PVM-1962

export const SwiperItemContainer = ({ slideItemWidth, slideItems, extraElement }: SwiperItemContainerProps) => {
  return (
    <CustomSwiper
      slidesPerView={'auto'}
      spaceBetween={SLIDE_GAP}
      slidesOffsetAfter={extraElement && extraElement.width + SLIDE_GAP}
    >
      {slideItems.map((slideItem, index) => (
        <CustomSwiperSlide width={slideItemWidth}>
          {slideItem}
          {extraElement && index === slideItems.length - 1 && extraElement.element}
        </CustomSwiperSlide>
      ))}
    </CustomSwiper>
  );
};

const CustomSwiper = styled(Swiper)`
  width: ${() => `calc(100% + ${SLIDE_GAP * 2}px)`};
  height: 100%;

  padding: ${() => `0px ${SLIDE_GAP}px`};

  transform: ${() => `translateX(-${SLIDE_GAP}px)`};

  gap: ${() => `${SLIDE_GAP}px`};
`;

const CustomSwiperSlide = styled(SwiperSlide)<{ width: number }>`
  width: ${(props) => `${props.width}px !important`};
  height: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  cursor: pointer;

  gap: ${() => `${SLIDE_GAP}px`};

  @media screen and (max-width: 340px) {
    width: ${(props) => `${props.width * 0.8}px !important`};
  }
`;
